import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.882 14.476c4.034 0 7.483.611 7.483 3.053S12.94 20.6 8.882 20.6c-4.035 0-7.482-.606-7.482-3.049s3.424-3.075 7.482-3.075M8.882 10.991a4.796 4.796 0 1 1 4.796-4.795 4.78 4.78 0 0 1-4.762 4.795z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.419 9.746A3.61 3.61 0 0 0 19.52 6.18a3.61 3.61 0 0 0-3.02-3.56M18.729 13.957c1.696.253 2.88.848 2.88 2.072 0 .844-.557 1.39-1.459 1.733"
    }, null, -1)
  ])))
}
export default { render: render }